<template>
    <div class="product mv_prod_row" :style="this.$store.getters.enableCheckout ? 'grid-template-columns:4fr auto' : ''"  >
        <component :is="components[product.class]" :product="product" :quantity="quantity" ref="component"></component>
        <template v-if="this.$store.getters.enableCheckout">
            <div class="ml-4" style="text-align:right">
            <button class="btn btn-primary"  @click="openProduct" >+</button>
            </div>
        </template>
    </div>
</template>

<script>
import SimpleProduct from './SimpleProduct'
import ComposableProduct from './ComposableProduct'
import PopupProductVue from './PopupProduct.vue'
import QtySelector from './QtySelector'
export default {
    props: ['product'],
    components: {
        QtySelector
    },
    data(){
        return {
            quantity: 1,
            components: {
                'simple': SimpleProduct,
                'composable': ComposableProduct
            }
        }
    },
    methods: {
        add(){
            let item = this.$refs.component.addToCart();
            if(item !== null){
                let input = {fields: item,quantity: this.quantity,idProduct:this.product.id};
                this.$store.dispatch('addToCart',input);
            }
        },
        openProduct() {
            this.$root.$emit('popup', {component: PopupProductVue, componentData: {product: this.product}})
        }
    }
}
</script>
